import { render } from "./VabeneAddProgramme.vue?vue&type=template&id=30527955&ts=true"
import script from "./VabeneAddProgramme.vue?vue&type=script&lang=ts"
export * from "./VabeneAddProgramme.vue?vue&type=script&lang=ts"

import "./VabeneAddProgramme.vue?vue&type=style&index=0&id=30527955&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__